(() => {
 const boot = () => {
  if (window.DGCartDrawer?.ready) return;
  let drawer = document.getElementById('dg-cart-drawer');
  if (!drawer) {
    const shell = document.querySelector('template[data-dg-cart-shell]');
    if (!shell) return;
    document.body.append(shell.content.cloneNode(true));
    drawer = document.getElementById('dg-cart-drawer');
  }
  if (!drawer) return;
  const mount = drawer.querySelector('[data-cart-mount]');
  const message = drawer.querySelector('[data-cart-message]');
  const retry = drawer.querySelector('[data-cart-retry]');
  const root = (drawer.dataset.rootUrl || '/').replace(/\/?$/, '/');
  const cartUrl = drawer.dataset.cartUrl || root + 'cart';
  const strings = {
    loading: 'Loading your cart…', loadError: 'Your cart could not be refreshed. Please try again.',
    updateError: 'The quantity could not be updated. Please check your cart and try again.',
    verifyError: 'Stock could not be checked. Please try again.',
    limit: 'You can add up to [count] more with the items already in your cart.',
    unavailable: 'This quantity is already in your cart, or this option is no longer available.'
  };
  try { Object.assign(strings, JSON.parse(document.getElementById('dg-cart-strings')?.textContent || '{}')); }
  catch { /* A missing translation/config block must not disable the cart button. */ }
  const states = new WeakMap();
  let mutating = false, refreshVersion = 0, opener, closeTimer;
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const selectedId = form => String(new FormData(form).get('id') || '');
  const primary = form => form.querySelector('[name="add"]');
  const say = text => { message.textContent = text || ''; message.hidden = !text; };
  const countText = (template, count) => template.replaceAll('[count]', String(count));
  const stockMessage = (form, text) => {
    let el = form.querySelector('[data-stock-message]');
    if (!el) { el = document.createElement('p'); el.dataset.stockMessage = ''; el.className = 'dg-stock-message'; el.setAttribute('role', 'status'); form.append(el); }
    el.textContent = text || ''; el.hidden = !text;
  };
  const formError = (form, text) => {
    const el = form.querySelector('[data-form-error]');
    if (el) { el.textContent = text || ''; el.hidden = !text; }
  };
  const request = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options });
    return response;
  };
  const updateCount = count => {
    document.querySelectorAll('[data-cart-count]:not([data-dg-cart-content]),[data-drawer-count]').forEach(el => { el.textContent = count; });
  };
  const show = () => {
    clearTimeout(closeTimer);
    drawer.removeAttribute('data-closing');
    if (drawer.open) return;
    opener = document.activeElement;
    document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    drawer.showModal();
    drawer.querySelector('[data-cart-close]').focus();
  };
  const finishClose = () => {
    clearTimeout(closeTimer);
    drawer.close();
    drawer.removeAttribute('data-closing');
  };
  const close = () => {
    if (!drawer.open || drawer.hasAttribute('data-closing')) return;
    if (reducedMotion()) { finishClose(); return; }
    drawer.setAttribute('data-closing', 'true');
    // Fallback covers a missing stylesheet or animationend interrupted by a resize.
    closeTimer = setTimeout(finishClose, 360);
  };
  async function refresh() {
    const version = ++refreshVersion;
    retry.hidden = true;
    mount.setAttribute('aria-busy', 'true'); mount.inert = true;
    try {
      const url = new URL(cartUrl, location.origin);
      url.searchParams.set('section_id', 'cart-drawer-content');
      url.searchParams.set('_dg', Date.now());
      const response = await request(url);
      if (!response.ok) throw new Error(strings.loadError);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = doc.querySelector('[data-dg-cart-content]');
      if (!content) throw new Error(strings.loadError);
      if (version !== refreshVersion) return;
      mount.replaceChildren(content);
      updateCount(Number(content.dataset.cartCount) || 0);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'dg-drawer' } }));
    } catch (error) {
      if (version !== refreshVersion) return;
      // Do not leave stale quantities or a stale checkout button interactive.
      mount.replaceChildren();
      say(strings.loadError);
      retry.hidden = false;
      throw error;
    } finally { if (version === refreshVersion) { mount.removeAttribute('aria-busy'); mount.inert = false; } }
  }
  async function open() { show(); say(''); try { await refresh(); } catch { /* Retry is visible. */ } }
  function applyStock(form, variant, clamp = true) {
    if (selectedId(form) !== String(variant.id)) return null;
    const input = form.querySelector('[name="quantity"]');
    const min = Math.max(1, Number(variant.minimum) || 1);
    const step = Math.max(1, Number(variant.step) || 1);
    const remaining = variant.maximum == null ? Infinity : Math.max(0, Number(variant.maximum) - Number(variant.inCart));
    const maximum = Number.isFinite(remaining) ? Math.max(0, min + Math.floor((remaining - min) / step) * step) : Infinity;
    const blocked = !variant.available || maximum < min;
    const state = { id: String(variant.id), min, step, maximum, blocked };
    states.set(form, state);
    if (input) {
      input.min = min; input.step = step;
      if (Number.isFinite(maximum)) input.max = maximum; else input.removeAttribute('max');
      if (clamp && !blocked) {
        const previous = Number(input.value) || min;
        input.value = Math.min(maximum, min + Math.max(0, Math.floor((previous - min) / step)) * step);
        if (previous > maximum) stockMessage(form, countText(strings.limit, maximum));
      }
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    const button = primary(form);
    if (button && !button.hasAttribute('aria-busy')) button.disabled = blocked;
    if (blocked) stockMessage(form, strings.unavailable);
    return state;
  }
  async function stock(form, clamp = true) {
    const id = selectedId(form);
    let productUrl = form.dataset.stockUrl;
    if (!productUrl) {
      const scope = form.closest('.product-card,[data-product-scope]');
      productUrl = scope?.querySelector('a[href*="/products/"]')?.getAttribute('href');
      if (!productUrl && location.pathname.includes('/products/')) productUrl = location.pathname;
    }
    if (!productUrl) throw new Error(strings.verifyError);
    const url = new URL(productUrl, location.origin);
    if (url.origin !== location.origin) throw new Error(strings.verifyError);
    url.searchParams.set('section_id', 'variant-stock'); url.searchParams.set('variant', id); url.searchParams.set('_dg', Date.now());
    const response = await request(url);
    if (!response.ok) throw new Error(strings.verifyError);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const json = doc.querySelector('[data-dg-stock]');
    if (!json) throw new Error(strings.verifyError);
    const data = JSON.parse(json.textContent);
    if (selectedId(form) !== id) return null;
    const variant = data.variants.find(item => String(item.id) === id);
    if (!variant) throw new Error(strings.verifyError);
    updateCount(data.count);
    return applyStock(form, variant, clamp);
  }
  const refreshForms = () => {
    document.querySelectorAll('[data-product-form]').forEach(form => {
      if (states.has(form) || form.querySelector('[name="quantity"]:not([type="hidden"])')) stock(form).catch(() => { /* Submit checks again and explains failures. */ });
    });
  };
  async function add(form) {
    if (mutating) return;
    mutating = true;
    const button = primary(form);
    const previousDisabled = button?.disabled;
    button?.setAttribute('aria-busy', 'true'); if (button) button.disabled = true;
    formError(form, ''); stockMessage(form, '');
    let attempted = false;
    try {
      const state = await stock(form, false);
      if (!state) return;
      const quantity = Number(new FormData(form).get('quantity') || 1);
      if (state.blocked) throw new Error(strings.unavailable);
      if (!Number.isInteger(quantity) || quantity < state.min || quantity > state.maximum || (quantity - state.min) % state.step !== 0) {
        const input = form.querySelector('[name="quantity"]');
        if (input) { input.value = Math.min(state.maximum, state.min + Math.max(0, Math.floor(((quantity || state.min) - state.min) / state.step)) * state.step); input.dispatchEvent(new Event('input', { bubbles: true })); }
        throw new Error(Number.isFinite(state.maximum) ? countText(strings.limit, state.maximum) : strings.updateError);
      }
      // Prevent a variant switch from changing the submitted variant while awaiting stock.
      const body = new FormData(form);
      if (String(body.get('id')) !== state.id) return;
      attempted = true;
      const response = await request(root + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await response.json();
      show();
      say(response.ok ? '' : (data.description || data.message || strings.updateError));
      await refresh();
      if (!response.ok) formError(form, data.description || data.message || strings.updateError);
    } catch (error) {
      formError(form, error.message || strings.updateError);
      if (attempted) { show(); say(error.message || strings.updateError); try { await refresh(); } catch { /* Retry is visible. Never repeat the add automatically. */ } }
    } finally {
      button?.removeAttribute('aria-busy');
      const state = states.get(form);
      if (button) button.disabled = state?.id === selectedId(form) ? state.blocked : previousDisabled;
      mutating = false;
      if (attempted) refreshForms();
    }
  }
  async function change(line, quantity) {
    if (mutating) return;
    mutating = true;
    say(''); mount.setAttribute('aria-busy', 'true'); mount.inert = true;
    const input = line.querySelector('[data-cart-quantity]');
    const min = Number(input.min) || 1, step = Number(input.step) || 1;
    const max = input.hasAttribute('max') ? Number(input.max) : Infinity;
    quantity = Math.max(0, Math.floor(Number(quantity) || 0));
    if (quantity !== 0) quantity = Math.min(max, min + Math.max(0, Math.floor((quantity - min) / step)) * step);
    if (quantity < min) quantity = 0;
    const key = line.dataset.lineKey;
    try {
      const response = await request(root + 'cart/change.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const data = await response.json();
      if (!response.ok) say(data.description || data.message || strings.updateError);
    } catch { say(strings.updateError); }
    finally {
      try { await refresh(); } catch { /* Retry is visible. */ }
      mutating = false;
      refreshForms();
      const replacement = [...mount.querySelectorAll('[data-cart-line]')].find(el => el.dataset.lineKey === key);
      (replacement?.querySelector('[data-cart-quantity]') || drawer.querySelector('[data-cart-close]')).focus({ preventScroll: true });
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault(); event.stopImmediatePropagation();
    add(form);
  }, true);
  const isCartTrigger = target => {
    const trigger = target.closest('[data-cart-open],.bag-button,#cart-icon-bubble,button[aria-controls="dg-cart-drawer"],a[href]');
    if (!trigger) return false;
    if (trigger.matches('[data-cart-open],.bag-button,#cart-icon-bubble,button[aria-controls="dg-cart-drawer"]')) return true;
    if (trigger.hasAttribute('download') || trigger.getAttribute('target') === '_blank') return false;
    const href = trigger.getAttribute('href');
    if (!href || href.startsWith('#')) return false;
    const url = new URL(href, location.origin);
    const cartPath = new URL(cartUrl, location.origin).pathname.replace(/\/+$/, '');
    return url.origin === location.origin && url.pathname.replace(/\/+$/, '') === cartPath;
  };
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !isCartTrigger(event.target)) return;
    event.preventDefault(); event.stopImmediatePropagation(); open();
  }, true);
  drawer.addEventListener('click', event => {
    if (event.target.closest('[data-cart-close]')) { event.preventDefault(); event.stopImmediatePropagation(); close(); return; }
    if (event.target.closest('[data-cart-retry]')) open();
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) { event.stopImmediatePropagation(); close(); return; }
    }
    const line = event.target.closest('[data-cart-line]'); if (!line) return;
    const input = line.querySelector('[data-cart-quantity]');
    const step = event.target.closest('[data-cart-step]');
    const adjust = event.target.closest('[data-cart-adjust]');
    if (step) change(line, Number(input.value) + Number(step.dataset.cartStep) * (Number(input.step) || 1));
    if (adjust) change(line, Number(adjust.dataset.cartAdjust));
    if (event.target.closest('[data-cart-remove]')) change(line, 0);
  }, true);
  drawer.addEventListener('cancel', event => { event.preventDefault(); close(); });
  drawer.addEventListener('animationend', event => { if (event.target === drawer && event.animationName === 'dg-cart-exit' && drawer.hasAttribute('data-closing')) finishClose(); });
  drawer.addEventListener('change', event => { if (event.target.matches('[data-cart-quantity]')) change(event.target.closest('[data-cart-line]'), event.target.value); });
  drawer.addEventListener('close', () => { if (opener?.isConnected) opener.focus({ preventScroll: true }); });
  document.addEventListener('change', event => {
    const form = event.target.closest('[data-product-form]'); if (!form) return;
    if (event.target.matches('[data-variant-option],[data-variant-select]')) { stockMessage(form, ''); stock(form).catch(() => {}); }
    if (event.target.matches('[name="quantity"]')) {
      const state = states.get(form);
      if (state?.id === selectedId(form) && !state.blocked && Number(event.target.value) > state.maximum) {
        event.target.value = state.maximum; event.target.dispatchEvent(new Event('input', { bubbles: true })); stockMessage(form, countText(strings.limit, state.maximum));
      }
    }
  });
  const observedForms = new WeakSet();
  const init = () => document.querySelectorAll('[data-product-form]').forEach(form => {
    if (observedForms.has(form)) return;
    observedForms.add(form);
    if (form.querySelector('[name="quantity"]:not([type="hidden"])')) stock(form).catch(() => {});
  });
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', refreshForms);
  window.DGCartDrawer = { ready: true, open, close };
  drawer.dataset.cartReady = 'true';
  init();
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
 else boot();
 document.addEventListener('shopify:section:load', boot);
})();
